(function () {
  'use strict';

  // The empty-cart slider is initialised by theme.js (slider_empty_carttype)
  // while the empty message is still hidden, so Flickity measures a zero-width
  // container and the cells collapse. This re-measures it as soon as the block
  // actually becomes visible, and initialises it if the theme never did.

  var SELECTOR = '[data-slider-id="slider_emp_cart"]';
  var timer = null;

  function isVisible(el) {
    return !!(el && el.offsetWidth > 0 && el.offsetHeight >= 0 && el.offsetParent !== null);
  }

  function instanceFor(el) {
    if (el._emptyCartFlickity) return el._emptyCartFlickity;
    if (window.Flickity && typeof window.Flickity.data === 'function') {
      return window.Flickity.data(el) || null;
    }
    return null;
  }

  function boot(el) {
    if (typeof window.Flickity === 'undefined' || !el.children.length) return null;
    try {
      var isMobile = window.innerWidth < 768;
      var flkty = new window.Flickity(el, {
        cellAlign: 'left',
        contain: true,
        pageDots: false,
        prevNextButtons: !isMobile,
        wrapAround: false,
        groupCells: false,
        adaptiveHeight: false,
        dragThreshold: 8,
        imagesLoaded: true,
        percentPosition: true
      });
      el._emptyCartFlickity = flkty;
      return flkty;
    } catch (e) {
      return null;
    }
  }

  function refresh() {
    document.querySelectorAll(SELECTOR).forEach(function (el) {
      if (!isVisible(el)) return;

      var flkty = instanceFor(el);

      if (!flkty) {
        flkty = boot(el);
        if (!flkty) return;
      }

      try {
        flkty.resize();
        setTimeout(function () {
          try { flkty.resize(); } catch (e) { /* noop */ }
        }, 200);
      } catch (e) { /* noop */ }
    });
  }

  function schedule(delay) {
    clearTimeout(timer);
    timer = setTimeout(refresh, delay || 120);
  }

  function start() {
    var drawer = document.querySelector('[data-cart-drawer]') || document.body;

    new MutationObserver(function () {
      schedule(120);
    }).observe(drawer, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class', 'style', 'hidden']
    });

    document.addEventListener('click', function (e) {
      if (!e.target || !e.target.closest) return;
      if (e.target.closest('[data-cart-drawer-toggle], [data-item-remove], [data-quantity-button], .cart__item__remove')) {
        schedule(350);
      }
    });

    window.addEventListener('resize', function () { schedule(200); });

    schedule(400);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
